import { create } from "zustand";

interface ProfileModalStore {
    isOpen: boolean;
    openProfileModal: () => void;
    closeProfileModal: () => void;
    activeTab: string;
    setActiveTab: (tab: string) => void;
}

export const useProfileModalStore = create<ProfileModalStore>((set) => ({
    isOpen: false,
    activeTab: "general",
    openProfileModal: () => set({ isOpen: true }),
    closeProfileModal: () => set({ isOpen: false }),
    setActiveTab: (tab) => set({ activeTab: tab }),
}));
